import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-facets-skeleton-grid',
    template: `
        <div class="facets-skeleton">
            <div class="facets-skeleton__header"></div>
            <div class="facets-skeleton__input-wrap" *ngFor="let item of getCount()">
                <div class="facets-skeleton__input-text"></div>
                <div class="facets-skeleton__input"></div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetsSkeletonGridComponent {
    @Input() count?: number = 4;

    getCount() {
        return Array(this.count);
    }
}
